import {
    GET_DRIVER,
    GET_DRIVER_SUCCESS,
    GET_DRIVER_FAILURE,
    CREATE_DRIVER,
    CREATE_DRIVER_SUCCESS,
    CREATE_DRIVER_FAILURE,
    UPDATE_DRIVER_PASSWORD,
    UPDATE_DRIVER_PASSWORD_SUCCESS,
    UPDATE_DRIVER_PASSWORD_FAILURE,
    GET_CALENDAR_USER,
    GET_CALENDAR_USER_SUCCESS,
    GET_CALENDAR_USER_FAILURE,
    CREATE_CALENDAR_USER,
    CREATE_CALENDAR_USER_SUCCESS,
    CREATE_CALENDAR_USER_FAILURE,
    UPDATE_CALENDAR_USER_PASSWORD,
    UPDATE_CALENDAR_USER_PASSWORD_SUCCESS,
    UPDATE_CALENDAR_USER_PASSWORD_FAILURE,
    UPDATE_CALENDAR_ACCESS,
    UPDATE_CALENDAR_ACCESS_SUCCESS,
    UPDATE_CALENDAR_ACCESS_FAILURE,
    RESET_TRANSPORT_USER
} from '../constants/transport_user.constants';

const initialState = {
    driver: {
        isLoading: true,
        data: null
    },
    calendarUser: {
        isLoading: true,
        data: null
    },
};

export const Transport_user = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_DRIVER:
        case CREATE_DRIVER:
        case UPDATE_DRIVER_PASSWORD:
            return {
                ...state,
                driver: { ...state.driver, isLoading: true }
            };
        case GET_DRIVER_SUCCESS:
        case CREATE_DRIVER_SUCCESS:
            return {
                ...state,
                driver: {
                    isLoading: false,
                    data: payload
                },
            };
        case GET_DRIVER_FAILURE:
        case CREATE_DRIVER_FAILURE:
        case UPDATE_DRIVER_PASSWORD_FAILURE:
        case UPDATE_DRIVER_PASSWORD_SUCCESS:
            return {
                ...state,
                driver: { ...state.driver, isLoading: false }
            };

        
        case GET_CALENDAR_USER:
        case CREATE_CALENDAR_USER:
        case UPDATE_CALENDAR_USER_PASSWORD:
        case UPDATE_CALENDAR_ACCESS:
            return {
                ...state,
                calendarUser: { ...state.calendarUser, isLoading: true }
            };
        case GET_CALENDAR_USER_SUCCESS:
        case CREATE_CALENDAR_USER_SUCCESS:
            return {
                ...state,
                calendarUser: {
                    isLoading: false,
                    data: payload
                },
            };
        case GET_CALENDAR_USER_FAILURE:
        case CREATE_CALENDAR_USER_FAILURE:
        case UPDATE_CALENDAR_USER_PASSWORD_FAILURE:
        case UPDATE_CALENDAR_USER_PASSWORD_SUCCESS:
        case UPDATE_CALENDAR_ACCESS_FAILURE:
        case UPDATE_CALENDAR_ACCESS_SUCCESS:
            return {
                ...state,
                calendarUser: { ...state.calendarUser, isLoading: false }
            };
        
        case RESET_TRANSPORT_USER:
            return {
                ...initialState
            };

        default:
            return state;
        }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/reducers/transport_user.reducers.js